import React from "react";
import { Clock, Store } from "lucide-react";

interface HeaderProps {
  dateLabel: string;
  selectedLojaId?: number;
  selectedLojaNome?: string;
}

export const Header: React.FC<HeaderProps> = ({
  dateLabel,
  selectedLojaId,
  selectedLojaNome,
}) => {
  return (
    <div className="mt-3 shrink-0 px-3 py-1.5 text-center sm:mt-4 sm:px-4 sm:py-2">
      <h1 className="mb-1 bg-gradient-to-r from-yellow-300 to-white bg-clip-text text-3xl font-black text-transparent sm:text-5xl lg:text-6xl">
        PROGRESSO POR SETOR
      </h1>
      <div className="mb-1 flex flex-col items-center justify-center gap-0.5 text-base opacity-75 sm:flex-row sm:gap-2 sm:text-lg lg:text-xl">
        <span className="flex items-center gap-1.5">
          <Clock className="h-4 w-4 sm:h-5 sm:w-5" />
          {dateLabel}
        </span>
        {selectedLojaId && selectedLojaNome ? (
          <>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center gap-1.5">
              <Store className="h-4 w-4 sm:h-5 sm:w-5" />
              {selectedLojaNome}
            </span>
          </>
        ) : !selectedLojaId ? (
          <>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center gap-1.5">
              <Store className="h-4 w-4 sm:h-5 sm:w-5" />
              Todas as lojas
            </span>
          </>
        ) : null}
      </div>
    </div>
  );
};
